import { Injectable } from '@angular/core';
import { List } from 'immutable';
import { Tax } from '../settings-data/sub-models/company-settings/tax.model';
import { UtilsService } from '../shared/services/utils/utils.service';
import { DocumentTypesEnum, ICopyDocumentOptions } from './document-data.data';
import { Document } from './document.model';

@Injectable({ providedIn: 'root' })
export class DocumentDataActionBuilder {
  constructor(private _utilsService: UtilsService) {}

  buildConvertToInvoiceOptions(
    taxes: List<Tax>,
    sourceDocument: Document
  ): ICopyDocumentOptions {
    return {
      sourceDocument,
      copyAs: DocumentTypesEnum.invoice,
      copyClient: true,
      copyItems: true,
      copyAttachments: true,
      saveCopy: true,
      copyTaxes: this._utilsService.checkTaxConflicts(taxes, sourceDocument),
    };
  }
}
